module.exports = __webpack_public_path__ + "61b6d9f00136c9c52df12167d64dc358.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-0.png
// module id = 3303
// module chunks = 0